module.exports = __webpack_public_path__ + "static/media/MPLAD YELLOW.2a5588d8.svg";